import axios from "axios";

export default (history = null) => {
    const axiosInstance = axios.create({
        withCredentials: true
    })
    
    axiosInstance.interceptors.response.use(
        (response) =>
            new Promise((resolve, reject) => {
                resolve(response);
            }),
        (error) => {
            if (!error.response) {
                return new Promise((resolve, reject) => {
                    reject(error);
                });
            }
            if (error.response.status === 401) {
                if(history){
                    history.push("/BancaVirtual/auth/login")
                }else{
                    window.location = "/BancaVirtual/auth/login";
                }
            } else {
                return new Promise((resolve, reject) => {
                    reject(error);
                });
            }
        }
    );

    return axiosInstance;
}